const type = 'SET_CARD_PASSWORD_CHANGE_SUBMITTING';

const setCardPasswordChangeSubmitting = (data) => ({
  data,
  type,
});

export { type };
export default setCardPasswordChangeSubmitting;
